"use strict";
import Handlebars from "handlebars/dist/handlebars.js";
import { displayGenericError, serviceNetworkError } from "../failhandler";

var scanLottery = (function() {

	var scanLotteryContainer = $('.scan-lottery');

	if (scanLotteryContainer.length > 0) {

		var main 			= $('#main'),
			scanBtn 		= $('.scan-lottery #scan-btn'),
			responseWrap  	= scanBtn.closest('.module').find('.response-wrapper'),
			invalidMessage  = responseWrap.attr('data-invalid-message'),
			responseModal   = $('.scan-lottery .response-modal'),
			scanSource      = $(".scan-lottery #scan-lottery-template").html(),
			scanTemplate    = Handlebars.compile(scanSource),
			cl              = new CanvasLoader('loader'),
			input           = main.find('input:text'),
            inputVal;

		cl.setDiameter(20);
		cl.setDensity(17);
		cl.setRange(1.1);
		cl.setSpeed(1);
		cl.setColor('#ffffff');
		cl.setFPS(24);

		scanBtn.removeAttr("type");

		main.on('click', '.close-modal', closeModal);
		main.on('click', '#scan-btn', scanTicket);

		input.focus();

		input.keydown(function (e) {
		    if (e.which == 13) {
		        if (e.preventDefault) {
		            e.preventDefault();
		        }
		        else {
		            e.returnValue = false;
		        }

		        scanBtn.click();
		    }
		});
	}

	function scanTicket(e) {
	    if (e.preventDefault) {
	        e.preventDefault();
	    }
	    else {
	        e.returnValue = false;
	    }

	    inputVal = input.val();

	    if (inputVal.length > 0) {

	        var data = {
	            "pageid": SETTINGS.pageid,
	            "language": SETTINGS.language,
                "code": inputVal
	        };

	        scanBtn.addClass('loading');
	        cl.show();
	        responseWrap.hide();

	        var ajaxRequest = $.ajax({
	            url: SETTINGS.services.forms.methods.scanLottery,
	            data: JSON.stringify(data)
	        });

	        ajaxRequest.done(doneHandler);
	        ajaxRequest.fail(failHandler);
	    }
	    else {

	        responseWrap.html(invalidMessage).show();
	        input.focus();
	    }

	    function doneHandler(response) {

	        if (response.Success) {            
                var html = scanTemplate(response.Data);
	            responseModal.append(html);

	            responseModal.show();

	        } else {

	            displayGenericError(responseWrap, response);	            	            	            
	        }
	        cl.hide();
	        scanBtn.removeClass('loading');
	    }

	    function failHandler(jqXHR, textStatus, errorThrown) {
	        serviceNetworkError(responseWrap);
	        scanBtn.removeClass('loading');
	        cl.hide();
	    }

	    return false;
	};

	function closeModal() {
	    input.val('');
	    input.focus();
	    responseModal.empty().hide();
	}
})();